module.exports = __webpack_public_path__ + "assets/612cdad5683b24ab1fdac0bb02ea69e7.png";